var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.999,
    height: 27.999,
    viewBox: "0 0 27.999 27.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-mail",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34949",
    "data-name": "Group 34949",
    transform: "translate(12.5 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M31.5,12h-10a.5.5,0,0,0,0,1h10a.5.5,0,0,0,0-1Z",
    transform: "translate(-21 -12)",
    fill: "#ff6c84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M31.5,18h-10a.5.5,0,0,0,0,1h10a.5.5,0,0,0,0-1Z",
    transform: "translate(-21 -15)",
    fill: "#ff6c84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M31.5,24h-10a.5.5,0,0,0,0,1h10a.5.5,0,0,0,0-1Z",
    transform: "translate(-21 -18)",
    fill: "#ff6c84",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M31.5,30h-10a.5.5,0,0,0,0,1h10a.5.5,0,0,0,0-1Z",
    transform: "translate(-21 -21)",
    fill: "#ff6c84",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M9.5,18.232V5.5A1.5,1.5,0,0,1,11,4H25a1.5,1.5,0,0,1,1.5,1.5V18.232l4.106-2.738a1.538,1.538,0,0,0-.213-.192L27.7,13.308a.5.5,0,1,1,.595-.8l2.69,1.993A2.5,2.5,0,0,1,32,16.507V29.5A2.5,2.5,0,0,1,29.5,32H6.5A2.5,2.5,0,0,1,4,29.5V16.507A2.5,2.5,0,0,1,5.012,14.5L7.7,12.5a.5.5,0,1,1,.595.8L5.607,15.3a1.538,1.538,0,0,0-.213.192Zm10.916,5.257-2.139,1.426a.5.5,0,0,1-.555,0l-2.139-1.426L5.954,30.9A1.5,1.5,0,0,0,6.5,31h23a1.5,1.5,0,0,0,.546-.1ZM31,16.435l-9.7,6.468,9.517,7.321A1.5,1.5,0,0,0,31,29.5V16.507c0-.024,0-.048,0-.072Zm-26,0c0,.024,0,.048,0,.072V29.5a1.5,1.5,0,0,0,.187.725L14.7,22.9ZM25.5,18.9V5.5A.5.5,0,0,0,25,5H11a.5.5,0,0,0-.5.5V18.9l7.5,5Z",
    transform: "translate(0 0)",
    fill: "#ff6c84",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMail);
export default __webpack_public_path__ + "static/media/open-mail.9acd14424714d16ed11be775d290e4ee.svg";
export { ForwardRef as ReactComponent };